export async function clipboard (text) {
  try {
    const data = [new window.ClipboardItem({ 'text/plain': new Blob([text], { type: 'text/plain' }) })]
    await navigator.clipboard.write(data)
    return true
  } catch (error) {
    return false
  }
}
